import { useMutation, useQueryClient } from '@tanstack/react-query';

import { buildSubmitClaimDTO } from './submitClaimDTO';
import { ClaimContext } from '../../parcel-finder/claims/types';
import useNotifications from '../../../hooks/useNotifications';
import { useSelectedShopId } from '../../../hooks/useSelectedShop';
import container from '../../../container';

function useSaveClaimDraftMutation(claim: ClaimContext) {
  const queryClient = useQueryClient();
  const { showNotice, showError } = useNotifications();
  const shopId = useSelectedShopId();

  return useMutation({
    mutationFn: async () => {
      const payload = buildSubmitClaimDTO(claim);
      if (claim.draftId) {
        return container.touchpointsApi.updateClaimDraft(shopId, claim.draftId, payload);
      }

      return container.touchpointsApi.createClaimDraft(shopId, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['claim'] });
      return showNotice({ type: 'success', message: 'CLAIM_DRAFT_SUCCESSFULLY_SAVED' });
    },
    onError: () => showError(),
  });
}

export default useSaveClaimDraftMutation;
